export default "__VITE_ASSET__Cort71PI__"